import { useId } from 'react'
import type { EliteConsentTextItem } from '../../../../types/misc.types'
import {
  AnimatedEliteSelectionCheckbox,
  eliteKycConsentCheckedBoxSvg,
  eliteKycConsentUncheckedBoxSvg
} from '../../../new-elite-landing/components/NewEliteLandingPlanSelector'
import { EliteConsentTextContent } from '../../../../components/elite/EliteConsentTextContent'
import { ElitePlansEventId, trackElitePlansClick } from '../../analytics'

export function ElitePlansConsentRow({
  planId,
  consentTextList,
  checked,
  onCheckedChange
}: {
  planId: string
  consentTextList: EliteConsentTextItem[]
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}) {
  const consentTextId = useId()

  return (
    <div className='mt-4 flex w-full items-start gap-3 text-left'>
      <span className='relative mt-0.5 shrink-0'>
        <input
          type='checkbox'
          checked={checked}
          aria-labelledby={consentTextId}
          onChange={() => {
            const next = !checked
            onCheckedChange(next)
            trackElitePlansClick(ElitePlansEventId.KycConsentToggle, {
              planId,
              buttonLabel: next ? 'Consent Checked' : 'Consent UnChecked'
            })
          }}
          className='peer absolute inset-0 z-10 m-0 h-full w-full cursor-pointer opacity-0'
        />
        <span className='block rounded-md peer-focus-visible:[outline:2px_solid_theme(colors.prime60)] peer-focus-visible:outline-offset-2'>
          <AnimatedEliteSelectionCheckbox
            checked={checked}
            checkedSvg={eliteKycConsentCheckedBoxSvg}
            uncheckedSvg={eliteKycConsentUncheckedBoxSvg}
          />
        </span>
      </span>
      <div
        id={consentTextId}
        className='ep-theme-tween min-w-0 flex-1 text-xs font-normal leading-[150%] text-[color:var(--ep-hero-body)]'
      >
        <EliteConsentTextContent consentTextList={consentTextList} />
      </div>
    </div>
  )
}
